var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin OH
 * @contact hjoh@detech.co.kr
 * @date 2023-07-10
 * @brief SEI 에너지컨설팅 개발
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
import { useNavigate } from "react-router-dom";
// recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { alertState, curConsultingState, noneUrl } from "../../../recoil/assessmentState";
import { detail, detailHistory, detailList, loadingBoxState, marketWork, tagName, urlState, } from "../../../recoil/menuState";
import { demo, reLoad, userInfoLoginState } from "../../../recoil/userState"; // recoil
// utils
import * as CONST from "../../../utils/Const";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
import { Trans } from "react-i18next";
import { langId } from "../../../recoil/langState";
import { useTrans } from "../../../utils/langs/useTrans";
import EhpPagination from "../../common/pagination/EhpPagination";
function ConsultingView(props) {
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const recoilTreeData = useRecoilValue(curConsultingState);
    const [reload, setReload] = useRecoilState(reLoad);
    const demos = useRecoilValue(demo);
    const langIds = useRecoilValue(langId);
    //props
    const { setNodata, etype, setEtype, sType, setStype, chenageZone, etypeB, setEtypeB, sTypeB, setStypeB } = props;
    //
    const [cont, setCont] = useState(1);
    const [consultingItem, setConsultingItem] = useState(null);
    // Mobile Check용
    const [isMobile, setMobile] = useState(false);
    useEffect(() => {
        // resize handler
        // Mobile 체크
        function handleResize() {
            if (window.innerWidth <= 940) {
                setMobile(true);
            }
            else {
                setMobile(false);
            }
        }
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    });
    // isMobile 여부 랜더링 후 확인
    useDebounceEffect(() => __awaiter(this, void 0, void 0, function* () {
        if (window.innerWidth <= 940) {
            setMobile(true);
        }
    }), 100);
    let appPath = "";
    if (demos) {
        appPath = `zoneId=LS ELECTRIC:청주`;
    }
    else {
        appPath = `zoneId=${recoilTreeData.zoneId}`;
    }
    // 컨설팅 점수 현황 API
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/energyconsulting/devicestatus?${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + reload,
    });
    useEffect(() => {
        setRecoilIsLoadingBox(true);
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setConsultingItem(data.body);
                setNodata(1);
                setReload(false);
                setRecoilIsLoadingBox(false);
            }
            else {
                // data.body.map((err) => (err.msg));
                setNodata(0);
                setConsultingItem(null);
                setReload(false);
                setRecoilIsLoadingBox(false);
            }
        }
    }, [data, reload]);
    //해당 위치 이동
    function ScrollMove(e, num) {
        e.preventDefault();
        const atag = document.getElementById("cont" + num);
        const offset = atag.offsetTop;
        window.scrollTo({
            top: offset,
        });
        setCont(num);
    }
    return (_jsx(_Fragment, { children: consultingItem ? (_jsx("div", Object.assign({ className: "box-wrap" }, { children: _jsxs("section", { children: [_jsx(Trans, Object.assign({ i18nKey: "컨설팅.CON1", values: {
                            zone: recoilTreeData.name,
                            energyEfficiency: consultingItem.energyEfficiency !== null ? consultingItem.energyEfficiency : "-",
                            assessmentScore: consultingItem.assessmentScore !== null ? consultingItem.assessmentScore : "-",
                            maxPowerUsage: consultingItem.maxPowerUsage !== null ? parseFloat(consultingItem.maxPowerUsage).toFixed(2) : "-",
                            deviceAge: consultingItem.deviceAge !== null ? consultingItem.deviceAge : "-",
                            pvGenerationExpectancy: consultingItem.pvGenerationExpectancy !== null ? consultingItem.pvGenerationExpectancy : "-",
                            amountEnergySaving: consultingItem.amountEnergySaving !== null
                                ? consultingItem.amountEnergySaving.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                : "-",
                            amountProfitExpectancy: consultingItem.amountProfitExpectancy !== null
                                ? consultingItem.amountProfitExpectancy.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                : "-",
                            headStatement: consultingItem.headStatement !== null ? consultingItem.headStatement : "",
                            safetyStatement: consultingItem.safetyStatement !== null ? consultingItem.safetyStatement : "",
                            content: consultingItem.content.length > 0 ? consultingItem.content.length : "",
                        } }, { children: _jsxs("article", Object.assign({ id: "cont1" }, { children: [_jsx("h2", { children: "Data\uB97C \uBD84\uC11D\uD574 SEI\uAC00 \uB9DE\uCDA4 \uCEE8\uC124\uD305\uD574\uB4DC\uB9BD\uB2C8\uB2E4." }), _jsx("div", Object.assign({ className: "helper-info" }, { children: _jsxs("p", { children: [_jsxs("span", { children: ["\uC548\uB155\uD558\uC138\uC694, ", recoilTreeData.name, " \uB2F4\uB2F9\uC790\uB2D8.", _jsx("br", {}), "\uC800\uB294 Smart Energy Insight\uC758 \uCEE8\uC124\uD134\uD2B8 \uBCFC\uD2B8 \uC785\uB2C8\uB2E4."] }), _jsxs("span", { children: ["\uC9C0\uAE08\uBD80\uD130 \uC81C\uAC00 ", recoilTreeData.name, " \uC124\uBE44 \uBC0F \uACF5\uACF5 \uB370\uC774\uD130\uB97C \uBC14\uD0D5\uC73C\uB85C \uBD84\uC11D\uD55C \uACB0\uACFC\uB97C \uBCF4\uC5EC\uB4DC\uB9B4\uAC8C\uC694."] })] }) })), _jsx("h3", Object.assign({ className: "hide" }, { children: "\uC0AC\uC5C5\uC7A5 \uC124\uBE44 \uBC0F \uACF5\uACF5\uB370\uC774\uD130 \uBD84\uC11D \uACB0\uACFC" })), _jsxs("div", Object.assign({ className: "consult-result-box" }, { children: [_jsx("p", Object.assign({ className: "title" }, { children: recoilTreeData.name })), _jsxs("ul", Object.assign({ className: "result-box" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uC5D0\uB108\uC9C0 \uD6A8\uC728 \uC810\uC218" })), _jsx("p", Object.assign({ className: "score-info" }, { children: _jsxs("span", Object.assign({ className: "score" }, { children: [_jsx("strong", { children: consultingItem.energyEfficiency !== null ? consultingItem.energyEfficiency : "-" }), "\uC810"] })) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uC804\uB825\uC124\uBE44 \uC9C4\uB2E8 \uC810\uAC80 \uC810\uC218" })), _jsx("p", Object.assign({ className: "score-info" }, { children: _jsxs("span", Object.assign({ className: "score" }, { children: [_jsx("strong", { children: consultingItem.assessmentScore !== null ? consultingItem.assessmentScore : "-" }), "\uC810"] })) }))] }), _jsxs("li", { children: [_jsxs("p", Object.assign({ className: "tit" }, { children: ["\uCD5C\uB300 \uC804\uB825 \uC0AC\uC6A9\uB960", _jsx("br", {}), _jsx("span", { children: "(\uCD5C\uADFC 1\uB144 \uACC4\uC57D\uC804\uB825 \uB300\uBE44)" })] })), _jsx("p", Object.assign({ className: "score-info" }, { children: _jsxs("span", Object.assign({ className: "score" }, { children: [_jsx("strong", { children: consultingItem.maxPowerUsage !== null
                                                                            ? parseFloat(consultingItem.maxPowerUsage).toFixed(2)
                                                                            : "-" }), "%"] })) }))] })] })), _jsxs("ul", Object.assign({ className: "result-box small" }, { children: [_jsxs("li", { children: [_jsxs("p", Object.assign({ className: "tit" }, { children: ["\uC124\uBE44 \uB178\uD6C4\uB3C4", _jsx("span", {})] })), _jsx("p", Object.assign({ className: "score-info" }, { children: _jsxs("span", Object.assign({ className: "score" }, { children: [_jsx("strong", { children: consultingItem.deviceAge !== null ? consultingItem.deviceAge : "-" }), "\uC810"] })) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "PV\uC608\uC0C1 \uBC1C\uC804\uB960" })), _jsx("p", Object.assign({ className: "score-info" }, { children: _jsxs("span", Object.assign({ className: "score" }, { children: [_jsx("strong", { children: consultingItem.pvGenerationExpectancy !== null
                                                                            ? consultingItem.pvGenerationExpectancy
                                                                            : "-" }), "%"] })) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uC5D0\uB108\uC9C0 \uC808\uAC10 \uAC00\uB2A5 \uAE08\uC561" })), _jsx("p", Object.assign({ className: "score-info" }, { children: _jsxs("span", Object.assign({ className: "score" }, { children: [_jsx("strong", { children: consultingItem.amountEnergySaving !== null
                                                                            ? consultingItem.amountEnergySaving.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                                                            : "-" }), "\uB9CC\uC6D0"] })) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uD310\uB9E4\uD615 PV \uC608\uC0C1 \uC218\uC775" })), _jsx("p", Object.assign({ className: "score-info" }, { children: _jsxs("span", Object.assign({ className: "score" }, { children: [_jsx("strong", { children: consultingItem.amountProfitExpectancy !== null
                                                                            ? consultingItem.amountProfitExpectancy.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                                                            : "-" }), "\uB9CC\uC6D0"] })) }))] })] }))] })), _jsxs("div", Object.assign({ className: "consult-result-txt" }, { children: [_jsxs("p", Object.assign({ className: "title" }, { children: [recoilTreeData.name, " \uC0AC\uC5C5\uC7A5\uC740"] })), _jsxs("p", Object.assign({ className: "method" }, { children: [consultingItem.headStatement !== null ? consultingItem.headStatement : "", _jsx("br", {}), consultingItem.safetyStatement !== null ? consultingItem.safetyStatement : ""] })), consultingItem.content.length > 0 && (_jsxs("div", Object.assign({ className: "point-wrap" }, { children: [_jsx("p", Object.assign({ className: "tit" }, { children: _jsxs("span", { children: ["\uD655\uC778\uD558\uC2E4 Point\uB294", " ", _jsxs("strong", { children: ["\uCD1D ", consultingItem.content.length > 0 ? consultingItem.content.length : "", "\uAC00\uC9C0"] }), " ", "\uC785\uB2C8\uB2E4."] }) })), _jsx("ul", Object.assign({ className: "point" }, { children: consultingItem.content.map((list, idx) => (_jsx("li", { children: list }, "enegyList_" + idx.toString()))) }))] }))), _jsx("div", Object.assign({ className: "helper-info" }, { children: _jsx("p", { children: _jsxs("span", { children: ["\uCEE8\uC124\uD305 \uACB0\uACFC\uC5D0 \uB530\uB978 \uC0C1\uC138\uD55C \uC81C\uC548\uC0AC\uD56D \uBC0F \uAD00\uB828 \uC194\uB8E8\uC158\uC744 \uBCF4\uAE30 \uC6D0\uD558\uC2DC\uBA74 'SEI \uC81C\uC548' \uB610\uB294 \uC194\uB8E8\uC158 \uB9C8\uCF13\uC744 \uBC29\uBB38\uD558\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.", _jsx("br", {}), "\uB610\uD55C \uC5D0\uB108\uC9C0Report \uBC1C\uD589\uD558\uC5EC \uB370\uC774\uD130 \uAE30\uBC18\uC758 \uC790\uC138\uD55C \uCEE8\uC124\uD305\uC744 \uACBD\uD5D8\uD574\uBCF4\uC138\uC694!"] }) }) }))] }))] })) })), _jsxs("article", Object.assign({ id: "cont2" }, { children: [_jsx("ul", { className: "locate" }), _jsx("h2", { children: t("컨설팅.CON2.제목") }), _jsx(EnergyConsulting, { isMobile: isMobile, etype: etype, setEtype: setEtype, chenageZone: chenageZone, etypeB: etypeB, setEtypeB: setEtypeB, t: t }), _jsx(SafetyConsultion, { isMobile: isMobile, sType: sType, setStype: setStype, sTypeB: sTypeB, setStypeB: setStypeB, t: t })] })), _jsx("article", { id: "cont3" })] }) }))) : (!consultingItem && (_jsx("div", Object.assign({ className: "box-wrap nodata" }, { children: _jsx("p", Object.assign({ className: "nodata__txt", style: { height: "95vh" } }, { children: t("컨설팅.NODATA") })) })))) }));
}
export default ConsultingView;
export function useDebounceEffect(fn, waitTime, deps) {
    useEffect(() => {
        const t = setTimeout(() => {
            fn.apply(undefined, deps);
        }, waitTime);
        return () => {
            clearTimeout(t);
        };
    }, deps);
}
function EnergyConsulting(props) {
    const navigate = useNavigate();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const recoilTreeData = useRecoilValue(curConsultingState);
    const setRecoilNoneUrlInfo = useSetRecoilState(noneUrl);
    const [urlInfo, setRecoilUrlInfo] = useRecoilState(urlState);
    const setRecoilDetail = useSetRecoilState(detail);
    const setRecoilDetailList = useSetRecoilState(detailList);
    const setRecoilMarkerWorks = useSetRecoilState(marketWork);
    const [alert, setAlert] = useRecoilState(alertState);
    const setRecoilTagName = useSetRecoilState(tagName);
    const [recoilHistory, setRecoilHistory] = useRecoilState(detailHistory);
    const demos = useRecoilValue(demo);
    // props
    const { isMobile, etype, setEtype, etypeB, setEtypeB, t } = props;
    //
    const [energyItem, setEnergyItem] = useState(null);
    // 페이징
    const defaultPageInfo = {
        size: 2,
        totalElements: 0,
        totalPages: 0,
        number: 0,
        psize: 10,
        listReload: false,
    };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    let appPath = "";
    appPath = `zoneId=${!demos ? recoilTreeData.zoneId : "LS ELECTRIC:청주"}&bigGroup=ENERGY&type=${etype}`;
    appPath = appPath + `&page=${pageInfo.number}&size=${isMobile ? 1 : 2}`;
    // 컨설팅 점수 현황 API
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/energyconsulting/recommendation?${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + reLoad,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setEnergyItem(data.body);
                setPageInfo(Object.assign({}, data.body.page /*  psize: (isMobile) ? 1 : 2, "listReload": false  */)); //5, 10; //5, 10
            }
            else {
                // data.body.map((err) => (err.msg));
            }
        }
    }, [data, reLoad]);
    useEffect(() => {
        if (energyItem && energyItem.solutions.length <= 0) {
            TypeClick(0);
            handleCurPage(0);
        }
        else {
            if (etypeB) {
                TypeClick(1); //5, 10; //5, 10
                handleCurPage(0);
                setEtypeB(false);
            }
        }
    }, [energyItem, etypeB]);
    function TypeClick(num) {
        setEtype(num);
        if (etype !== num || etypeB) {
            handleCurPage(0);
        }
    }
    // 마켓플레이스 이동
    function onClickGoMarket(e) {
        setRecoilDetailList(null);
        setRecoilDetail(false);
        setRecoilMarkerWorks("LIST");
        setRecoilNoneUrlInfo(false);
        setRecoilUrlInfo(CONST.URL_MARKETPLACE);
        navigate(CONST.URL_MARKETPLACE);
        localStorage.setItem("loginintro", CONST.URL_MARKETPLACE);
        setRecoilHistory(Object.assign(Object.assign({}, recoilHistory), { page: 0, bigGroup: "energy", searchKind: 0, searchLike: "", searchFilter: "", zone: false, zoneId: null, tagSearch: [] }));
    }
    //상담 신청 이동
    function IntroductioninquiryGo(e) {
        setRecoilNoneUrlInfo(false);
        setRecoilUrlInfo(CONST.URL_INTRODUCTIONINQUIRY);
        navigate(CONST.URL_INTRODUCTIONINQUIRY);
    }
    // 마켓플레이스 상세 이동
    function ViewGo(list) {
        return __awaiter(this, void 0, void 0, function* () {
            let appPath = "";
            if (userInfo.loginInfo.token) {
                appPath = `/energyconsulting/solution/${list.solutionId}/counting`;
            }
            else {
                appPath = `/energyconsulting/solution/${list.solutionId}/counting/landing`;
            }
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: appPath,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setRecoilDetailList(list);
                    setRecoilHistory(Object.assign(Object.assign({}, recoilHistory), { page: 0, bigGroup: "energy", searchKind: 0, searchLike: "", searchFilter: "", zone: false, zoneId: null }));
                    setRecoilDetail(true);
                    setRecoilMarkerWorks("VIEW");
                    setRecoilNoneUrlInfo(true);
                    setRecoilUrlInfo(CONST.URL_MARKETPLACE);
                    navigate(CONST.URL_MARKETPLACE);
                    localStorage.setItem("loginintro", CONST.URL_MARKETPLACE);
                }
                else {
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList == null ? data.soultion : data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    // 태그 클릭 시
    function TagClick(tagName) {
        CUTIL.jsclose_Popup("pop-whatwedo");
        setRecoilTagName(tagName);
        setRecoilMarkerWorks("LIST");
        setRecoilDetail(false);
        setRecoilNoneUrlInfo(true);
        setRecoilUrlInfo(CONST.URL_MARKETPLACE);
        navigate(CONST.URL_MARKETPLACE);
        localStorage.setItem("loginintro", CONST.URL_MARKETPLACE);
        setRecoilHistory(Object.assign(Object.assign({}, recoilHistory), { page: 0, bigGroup: "energy", searchKind: 0, searchLike: "", searchFilter: "", zone: false, zoneId: null }));
    }
    return (_jsx(_Fragment, { children: energyItem && (_jsxs("div", Object.assign({ className: "solution" }, { children: [_jsxs("h3", { children: ["ENERGY", _jsx("p", Object.assign({ className: "txt-info" }, { children: t("컨설팅.CON2.분석", [t("컨설팅.CON2.ENERGY")]) }))] }), _jsx("ul", Object.assign({ className: "sol-txt" }, { children: energyItem.statements.map((list, idx) => (_jsxs("li", { children: ["- ", list] }, "statements_" + idx.toString()))) })), _jsxs("div", Object.assign({ className: "solution-area" }, { children: [_jsxs("p", Object.assign({ className: "txt-info" }, { children: [" ", t("컨설팅.CON2.솔루션추천범위")] })), _jsxs("div", Object.assign({ className: "top" }, { children: [_jsxs("ul", Object.assign({ className: "tab__line" }, { children: [_jsx("li", Object.assign({ className: `${etype == 1 ? "on" : ""}`, onClick: (e) => etype > 0 && TypeClick(1) }, { children: _jsx("a", Object.assign({ onClick: (e) => e.preventDefault(), href: "#" }, { children: t("컨설팅.CON2.밀착맞춤") })) })), _jsx("li", Object.assign({ className: `${etype == 2 ? "on" : ""}`, onClick: (e) => etype > 0 && TypeClick(2) }, { children: _jsx("a", Object.assign({ onClick: (e) => e.preventDefault(), href: "#" }, { children: t("컨설팅.CON2.유사사업군맞춤") })) })), _jsx("li", Object.assign({ className: `${etype == 3 ? "on" : ""}`, onClick: (e) => etype > 0 && TypeClick(3) }, { children: _jsx("a", Object.assign({ onClick: (e) => e.preventDefault(), href: "#" }, { children: t("컨설팅.CON2.더많은솔루션") })) }))] })), _jsx("div", Object.assign({ className: "right" }, { children: _jsx("button", Object.assign({ type: "button", className: "btn-basic", onClick: (e) => onClickGoMarket(e) }, { children: _jsxs("span", Object.assign({ className: "icon-go" }, { children: [" ", t("컨설팅.CON2.전체솔루션보기")] })) })) }))] })), _jsx("ul", Object.assign({ className: "item-list" }, { children: energyItem.solutions.map((list, idx) => (_jsxs("li", { children: [_jsxs("div", Object.assign({ className: "img-wrap" }, { children: [" ", !list.imageUrl && (_jsxs("p", Object.assign({ className: "tit" }, { children: [_jsx("strong", { children: list.solutionName }), _jsx("span", { children: list.solutionSubTitle })] }))), _jsx("img", { src: list.imageUrl ? list.imageUrl : require("/static/img/default.png") })] })), _jsxs("div", Object.assign({ className: "item-info" }, { children: [_jsxs("div", Object.assign({ className: "item-info-top" }, { children: [_jsx("p", Object.assign({ className: "keyword" }, { children: list.solutionTag.map((hashTag, i) => (_jsx("span", Object.assign({ style: { cursor: "pointer" }, onClick: (e) => TagClick(hashTag) }, { children: hashTag }), "hash_" + i))) })), _jsx("p", Object.assign({ className: "tit" }, { children: list.solutionName })), _jsx("p", { className: "company" }), _jsx("p", Object.assign({ className: "cont" }, { children: list.description })), _jsx("ul", Object.assign({ className: "etc" }, { children: _jsx("li", { children: list.extraInfo }) }))] })), _jsxs("div", Object.assign({ className: "item-info-btnarea" }, { children: [_jsx("button", { children: _jsx("span", Object.assign({ className: "icon-go", onClick: (e) => IntroductioninquiryGo(e) }, { children: t("라벨.상담신청하기") })) }), _jsx("button", { children: _jsx("span", Object.assign({ className: "icon-more", onClick: (e) => ViewGo(list) }, { children: t("라벨.상세보기") })) })] }))] }))] }, "energySoluttions_" + idx.toString()))) })), _jsx(EhpPagination, { componentName: "ENERGY", pageInfo: pageInfo, handleCurPage: handleCurPage, solution: "solution" })] }))] }))) }));
}
function SafetyConsultion(props) {
    const navigate = useNavigate();
    const demos = useRecoilValue(demo);
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const recoilTreeData = useRecoilValue(curConsultingState);
    const setRecoilNoneUrlInfo = useSetRecoilState(noneUrl);
    const [urlInfo, setRecoilUrlInfo] = useRecoilState(urlState);
    const setRecoilDetail = useSetRecoilState(detail);
    const setRecoilDetailList = useSetRecoilState(detailList);
    const setRecoilMarkerWorks = useSetRecoilState(marketWork);
    const [alert, setAlert] = useRecoilState(alertState);
    const setRecoilTagName = useSetRecoilState(tagName);
    const [recoilHistory, setRecoilHistory] = useRecoilState(detailHistory);
    // props
    const { isMobile, sType, setStype, sTypeB, setStypeB, t } = props;
    //
    const [safetyItem, setSafetyItem] = useState(null);
    // 페이징
    const defaultPageInfo = {
        size: 2,
        totalElements: 0,
        totalPages: 0,
        number: 0,
        psize: 10,
        listReload: false,
    };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    let appPath = `zoneId=${!demos ? recoilTreeData.zoneId : "LS ELECTRIC:청주"}&bigGroup=SAFETY&type=${sType}`;
    appPath = appPath + `&page=${pageInfo.number}&size=${isMobile ? 1 : 2}`;
    // 컨설팅 점수 현황 API
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/energyconsulting/recommendation?${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + reLoad,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setSafetyItem(data.body);
                setPageInfo(Object.assign({}, data.body.page /* psize: (isMobile) ? 1 : 2, "listReload": false */)); //5, 10; //5, 10
            }
            else {
                // data.body.map((err) => (err.msg));
            }
        }
    }, [data, reLoad]);
    useEffect(() => {
        if (safetyItem && safetyItem.solutions.length <= 0) {
            TypeClick(0);
            handleCurPage(0);
        }
        else {
            if (sTypeB) {
                TypeClick(1); //5, 10; //5, 10
                handleCurPage(0);
                setStypeB(false);
            }
        }
    }, [safetyItem, sTypeB]);
    function TypeClick(num) {
        setStype(num);
        if (sType !== num || sTypeB) {
            handleCurPage(0);
        }
    }
    // 마켓플레이스이동
    function onClickGoMarket(e) {
        setRecoilDetailList(null);
        setRecoilDetail(false);
        setRecoilMarkerWorks("LIST");
        setRecoilNoneUrlInfo(false);
        setRecoilUrlInfo(CONST.URL_MARKETPLACE);
        navigate(CONST.URL_MARKETPLACE);
        localStorage.setItem("loginintro", CONST.URL_MARKETPLACE);
        setRecoilHistory(Object.assign(Object.assign({}, recoilHistory), { page: 0, bigGroup: "energy", searchKind: 0, searchLike: "", searchFilter: "", zone: false, zoneId: null, tagSearch: [] }));
    }
    //상담 신청 이동
    function IntroductioninquiryGo(e) {
        setRecoilNoneUrlInfo(false);
        setRecoilUrlInfo(CONST.URL_INTRODUCTIONINQUIRY);
        navigate(CONST.URL_INTRODUCTIONINQUIRY);
    }
    function ViewGo(list) {
        return __awaiter(this, void 0, void 0, function* () {
            let appPath = "";
            if (userInfo.loginInfo.token) {
                appPath = `/energyconsulting/solution/${list.solutionId}/counting`;
            }
            else {
                appPath = `/energyconsulting/solution/${list.solutionId}/counting/landing`;
            }
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: appPath,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setRecoilDetailList(list);
                    setRecoilHistory(Object.assign(Object.assign({}, recoilHistory), { page: 0, bigGroup: "energy", searchKind: 0, searchLike: "", searchFilter: "", zone: false, zoneId: null }));
                    setRecoilDetail(true);
                    setRecoilMarkerWorks("VIEW");
                    setRecoilNoneUrlInfo(true);
                    setRecoilUrlInfo(CONST.URL_MARKETPLACE);
                    navigate(CONST.URL_MARKETPLACE);
                    localStorage.setItem("loginintro", CONST.URL_MARKETPLACE);
                }
                else {
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList == null ? data.soultion : data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    // 태그 클릭 시
    function TagClick(tagName) {
        CUTIL.jsclose_Popup("pop-whatwedo");
        setRecoilTagName(tagName);
        setRecoilMarkerWorks("LIST");
        setRecoilDetail(false);
        setRecoilNoneUrlInfo(true);
        setRecoilUrlInfo(CONST.URL_MARKETPLACE);
        navigate(CONST.URL_MARKETPLACE);
        localStorage.setItem("loginintro", CONST.URL_MARKETPLACE);
        setRecoilHistory(Object.assign(Object.assign({}, recoilHistory), { page: 0, bigGroup: "energy", searchKind: 0, searchLike: "", searchFilter: "", zone: false, zoneId: null }));
    }
    return (_jsx(_Fragment, { children: safetyItem && (_jsxs("div", Object.assign({ className: "solution" }, { children: [_jsxs("h3", { children: ["SAFETY", _jsx("p", Object.assign({ className: "txt-info" }, { children: t("컨설팅.CON2.분석", [t("컨설팅.CON2.SAFETY")]) }))] }), _jsx("ul", Object.assign({ className: "sol-txt" }, { children: safetyItem.statements.map((list, idx) => (_jsxs("li", { children: ["- ", list] }, "statements_" + idx.toString()))) })), _jsxs("div", Object.assign({ className: "solution-area" }, { children: [_jsxs("p", Object.assign({ className: "txt-info" }, { children: [" ", t("컨설팅.CON2.솔루션추천범위")] })), _jsxs("div", Object.assign({ className: "top" }, { children: [_jsxs("ul", Object.assign({ className: "tab__line" }, { children: [_jsx("li", Object.assign({ className: `${sType == 1 ? "on" : ""}`, onClick: (e) => sType > 0 && TypeClick(1) }, { children: _jsx("a", Object.assign({ onClick: (e) => e.preventDefault(), href: "#" }, { children: t("컨설팅.CON2.밀착맞춤") })) })), _jsx("li", Object.assign({ className: `${sType == 2 ? "on" : ""}`, onClick: (e) => sType > 0 && TypeClick(2) }, { children: _jsx("a", Object.assign({ onClick: (e) => e.preventDefault(), href: "#" }, { children: t("컨설팅.CON2.유사사업군맞춤") })) })), _jsx("li", Object.assign({ className: `${sType == 3 ? "on" : ""}`, onClick: (e) => sType > 0 && TypeClick(3) }, { children: _jsx("a", Object.assign({ onClick: (e) => e.preventDefault(), href: "#" }, { children: t("컨설팅.CON2.더많은솔루션") })) }))] })), _jsx("div", Object.assign({ className: "right" }, { children: _jsx("button", Object.assign({ type: "button", className: "btn-basic", onClick: (e) => onClickGoMarket(e) }, { children: _jsxs("span", Object.assign({ className: "icon-go" }, { children: [" ", t("컨설팅.CON2.전체솔루션보기")] })) })) }))] })), _jsx("ul", Object.assign({ className: "item-list" }, { children: safetyItem.solutions.map((list, idx) => (_jsxs("li", { children: [_jsxs("div", Object.assign({ className: "img-wrap" }, { children: [!list.imageUrl && (_jsxs("p", Object.assign({ className: "tit" }, { children: [_jsx("strong", { children: list.solutionName }), _jsx("span", { children: list.solutionSubTitle })] }))), _jsx("img", { src: list.imageUrl ? list.imageUrl : require("/static/img/default.png") })] })), _jsxs("div", Object.assign({ className: "item-info" }, { children: [_jsxs("div", Object.assign({ className: "item-info-top" }, { children: [_jsx("p", Object.assign({ className: "keyword" }, { children: list.solutionTag.map((hashTag, i) => (_jsx("span", Object.assign({ style: { cursor: "pointer" }, onClick: (e) => TagClick(hashTag) }, { children: hashTag }), "hash_" + i))) })), _jsx("p", Object.assign({ className: "tit" }, { children: list.solutionName })), _jsx("p", { className: "company" }), _jsx("p", Object.assign({ className: "cont" }, { children: list.description })), _jsx("ul", Object.assign({ className: "etc" }, { children: _jsx("li", { children: list.extraInfo }) }))] })), _jsxs("div", Object.assign({ className: "item-info-btnarea" }, { children: [_jsx("button", { children: _jsx("span", Object.assign({ className: "icon-go", onClick: (e) => IntroductioninquiryGo(e) }, { children: t("라벨.상담신청하기") })) }), _jsx("button", Object.assign({ onClick: (e) => ViewGo(list) }, { children: _jsxs("span", Object.assign({ className: "icon-more" }, { children: [" ", t("라벨.상세보기")] })) }))] }))] }))] }, "energySoluttions_" + idx.toString()))) })), _jsx(EhpPagination, { componentName: "SAFETY", pageInfo: pageInfo, handleCurPage: handleCurPage, solution: "solution" })] }))] }))) }));
}
function MiddleSoulction(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const recoilTreeData = useRecoilValue(curConsultingState);
    const reload = useRecoilValue(reLoad);
    const [middleItem, setMiddleItem] = useState([]);
    const [midId, setMidId] = useState(null);
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/energyconsulting/middlegroups`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: recoilTreeData.zoneId + reload,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setMiddleItem(data.body);
                setMidId(data.body[0]);
            }
            else {
                // data.body.map((err) => (err.msg));
            }
        }
    }, [data, reload, recoilTreeData.zoneId]);
    function MiddleClick(e, item) {
        e.preventDefault();
        setMidId(item);
    }
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "product" }, { children: [_jsxs("h3", { children: [_jsx("span", Object.assign({ className: "hide" }, { children: "\uC194\uB8E8\uC158 \uC815\uBCF4 \uC790\uC138\uD788\uBCF4\uAE30" })), _jsx("p", Object.assign({ className: "txt-info" }, { children: "\uC194\uB8E8\uC158 \uBD84\uB958" }))] }), _jsx("div", Object.assign({ className: "scrollX" }, { children: _jsx("ul", Object.assign({ className: "tab__line" }, { children: middleItem.map((item, idx) => (_jsx("li", Object.assign({ className: `click-tab ${item.id == midId.id ? "on" : ""}`, "data-tab": "tab-" + item.id, onClick: (e) => MiddleClick(e, item) }, { children: _jsxs("a", Object.assign({ href: "#" }, { children: [_jsx("div", Object.assign({ className: "" }, { children: _jsx("img", { src: require("/static/img/bg_sol_1.png"), alt: "" }) })), _jsx("p", { children: item.name })] })) }), "mid_" + idx.toString()))) })) })), _jsx("ul", Object.assign({ className: "tab__line mt-26" }, { children: _jsx("li", Object.assign({ className: "click-tab on", "data-tab": "tab-1" }, { children: "\uAC1C\uC694" })) })), middleItem
                    .filter((idf) => idf.id == midId.id)
                    .map((list, idx) => (_jsx("div", Object.assign({ className: "tab-content show", id: "tab-" + list.id }, { children: _jsxs("div", Object.assign({ className: "scrollH" }, { children: [_jsx("p", Object.assign({ className: "tit" }, { children: list.name })), _jsx("p", { children: list.description })] })) }), "midList_" + idx.toString()))), _jsx("div", Object.assign({ className: "tab-content", id: "tab-2" }, { children: _jsx("p", { children: "\uAD00\uB828 \uC194\uB8E8\uC158 \uB0B4\uC6A9" }) }))] })) }));
}
